"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSmartColumnNames = exports.bulkEditFinders = exports.finders = exports.belongToThisSet = void 0;
var types_1 = require("./types");
/**
 * CSV import column auto-detection.
 *
 * Pure logic moved out of `client/src/components/domain/csv/PreviewCsv.tsx` so it
 * can be unit-tested with Jest. Behaviour is unchanged — this is a verbatim move.
 */
var defaultIgnoreColumns = [
    'setCode',
    'nameDE',
    'nameES',
    'nameFR',
    'nameIT',
    'rarity',
    'listedAt',
];
var belongToThisSet = function (value, set) {
    return set.filter(function (word) { return value.toLowerCase().split(/\s+/g).includes(word); }).length > 0;
};
exports.belongToThisSet = belongToThisSet;
exports.finders = {
    quantity: function (value) {
        return (0, exports.belongToThisSet)(value, [
            'qty',
            'qta',
            'qtx',
            'quantity',
            'number',
            'stock',
            'num',
            'count',
            'amount',
            '',
        ]);
    },
    name: function (value) { return (0, exports.belongToThisSet)(value, ['name', 'nome', 'card', 'cardname', 'title']); },
    expansion: function (value) {
        return (0, exports.belongToThisSet)(value, [
            'set',
            'name',
            'exp',
            'expansion',
            'expcod',
            'codexpansion',
            'codexp',
            'idexpansion',
            'edition',
            'setname',
            'setcode',
            'code',
        ]);
    },
    cn: function (value) { return (0, exports.belongToThisSet)(value, ['collector', 'number', 'collectornum', 'cn']); },
    condition: function (value) { return (0, exports.belongToThisSet)(value, ['condition', 'status', 'stato', 'state']); },
    language: function (value) { return (0, exports.belongToThisSet)(value, ['language', 'lan', 'lingua', 'lang']); },
    foil: function (value) { return (0, exports.belongToThisSet)(value, ['foil', 'isfoil', 'finish']); },
    signed: function (value) { return (0, exports.belongToThisSet)(value, ['signed', 'issigned']); },
    firstEd: function (value) {
        return (0, exports.belongToThisSet)(value, [
            'firsted',
            'first',
            'edition',
            'primaedizione',
            'prima',
            'edizione',
            'isfirst',
            'isfirsted',
        ]);
    },
    reverseHolo: function (value) {
        return (0, exports.belongToThisSet)(value, ['reverseholo', 'isreverseholo', 'reversefoil', 'isreversefoil']);
    },
    // `buyPrice` must be evaluated before `price`: a "buy price" header tokenises to
    // ['buy', 'price'] and both finders match it — first match wins.
    buyPrice: function (value) {
        return (0, exports.belongToThisSet)(value, ['buyprice', 'buy_price', 'cost', 'costo', 'buy']);
    },
    price: function (value) { return (0, exports.belongToThisSet)(value, ['price', 'prezzo', '€', '$', 'cash']); },
    comment: function (value) { return (0, exports.belongToThisSet)(value, ['comment', 'commenti', 'remark', 'critics']); },
    mkmId: function (value) {
        return (0, exports.belongToThisSet)(value, ['mkm', 'mkmid', 'cardmarket', 'cmid', 'cardmarketid']);
    },
    scryfallId: function (value) { return (0, exports.belongToThisSet)(value, ['scryfallid', 'scryfall']); },
    tcgplayerId: function (value) { return (0, exports.belongToThisSet)(value, ['tcgplayerid', 'tcgplayer']); },
    finishType: function (value) { return (0, exports.belongToThisSet)(value, ['finishtype', 'finish_type', 'finish']); },
};
/**
 * Kept out of `finders`: `getSmartColumnNames` feeds the PreviewCsv column
 * dropdown, which has no countryEdition option. Only the CSV bulk edit flow
 * uses this set. `countryEdition` comes first so a "country edition" header
 * isn't captured by the 'edition' token of `expansion`/`firstEd`.
 */
exports.bulkEditFinders = __assign({ countryEdition: function (value) { return (0, exports.belongToThisSet)(value, ['countryedition', 'country_edition']); } }, exports.finders);
var checkGame = function (found, gameCode) {
    if (gameCode === types_1.IdGame.Magic) {
        var firstEdIndex = found.findIndex(function (colName) { return colName === 'firstEd'; });
        if (firstEdIndex > -1)
            found[firstEdIndex] = 'ToBeSet';
        return found;
    }
    else {
        return found;
    }
};
var getSmartColumnNames = function (jsonCsv, gameCode) {
    var headerNames = Object.keys(jsonCsv[0] || {});
    var found = [];
    for (var i = 0; i < headerNames.length; i++) {
        var colNameFound = false;
        var _loop_1 = function (key) {
            if (exports.finders[key](headerNames[i]) && !found.find(function (foundedValue) { return foundedValue === key; })) {
                found.push(key);
                colNameFound = true;
                return "break";
            }
        };
        for (var key in exports.finders) {
            var state_1 = _loop_1(key);
            if (state_1 === "break")
                break;
        }
        if (!colNameFound) {
            if (defaultIgnoreColumns.includes(headerNames[i])) {
                found.push('-');
            }
            else {
                found.push('ToBeSet');
            }
        }
    }
    return checkGame(found, gameCode);
};
exports.getSmartColumnNames = getSmartColumnNames;
//# sourceMappingURL=csvColumnDetection.js.map